import { render } from "./ChooseAction.vue?vue&type=template&id=de8a7614&scoped=true"
import script from "./ChooseAction.vue?vue&type=script&lang=js"
export * from "./ChooseAction.vue?vue&type=script&lang=js"

import "./ChooseAction.vue?vue&type=style&index=0&id=de8a7614&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de8a7614"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
